/**
 * Helper function to handle selecting nested fields from a string path
 * @param {*} obj - The Object to traverse.. eg errors obj from React Hook Form
 * @param {*} path - The dot notation path to look up in the object, Eg 'friends.0.firstname'
 */
export const getValue = (obj, path) => {
  if (!path.includes('.')) {
    return obj[path];
  }

  return path
    .split('.')
    .filter((t) => t !== '')
    .reduce((prev, cur) => prev && prev[cur], obj);
};
